import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js";
import { useEffect } from "react";
import { IHook } from "./modalClaimPrizeStepPhone.types";

export const useModalClaimPrizeStepPhone: IHook = ({
  tempPhoneNumber,
  setPhoneNumber,
}) => {
  useEffect(() => {
    if (!isValidPhoneNumber(tempPhoneNumber, "FR") || !setPhoneNumber) {
      return;
    }

    const phoneNumber = parsePhoneNumber(tempPhoneNumber, "FR");

    setPhoneNumber(phoneNumber.number);
  }, [setPhoneNumber, tempPhoneNumber]);
};
